import { UI, Utils } from 'common';
import React, { Component } from 'react';

const { WrappedButton, InlineMessage, Frame, Typography } = UI;
const { Session, Logger, Navigation } = Utils;

export class Labs extends Component {
	constructor(props) {
		super(props);

		Session.setFormStateDirty(false);

		this.state = {
			saving: false,
			error: false,
		};
	}

	onEnableClick = async () => {
		Logger.saveActionData('Labs - Try Faster Experience Clicked', {
			defaultUI: 'Lazarus',
		});

		this.setState({ saving: true, error: false });

		try {
			const response = await Session.savePreferences([
				{ Name: 'DefaultUI', Value: 'Lazarus' },
			]);

			if (
				response &&
				(response.httpStatus === 200 || response.status === 'Success')
			) {
				var hostname = window.location.hostname;
				var protocol = window.location.protocol;
				var normalizedHostname = hostname.toLowerCase();
				var lazarusHost =
					normalizedHostname === 'corp.stamps.com' ||
					normalizedHostname.endsWith('.corp.stamps.com')
						? hostname + ':8443'
						: hostname
								.replace(/^print\./, 'app.web.')
								.replace(
									/^(account|contacts|history|mail|products)\.web\./,
									'app.web.'
								);
				window.location.href =
					protocol + '//' + lazarusHost + '/#/account/account-settings/labs';
			} else {
				this.setState({ saving: false, error: true });
			}
		} catch (error) {
			console.error('Labs save error:', error);
			this.setState({ saving: false, error: true });
		}
	};

	render() {
		const { saving, error } = this.state;

		return (
			<div className="account-labs">
				<Typography.H3>Labs</Typography.H3>

				<Typography.P>
					Test drive experimental features and new functionality. Features in
					beta are being actively developed and may change at any time.
				</Typography.P>

				<Frame className="feature-tile">
					<div className="content">
						<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
							<Typography.H4 style={{ margin: 0 }}>
								Accelerated Performance with Stamps.com
							</Typography.H4>
							<span
								style={{
									display: 'inline-flex',
									alignItems: 'center',
									padding: '2px 8px',
									fontSize: '12px',
									lineHeight: '16px',
									fontWeight: 500,
									color: '#484F59',
									backgroundColor: '#FFFFFF',
									border: '1px solid #E1E4E8',
									borderRadius: '16px',
									whiteSpace: 'nowrap',
								}}
							>
								Opted-Out
							</span>
						</div>

						<Typography.P style={{ color: '#656C76', fontSize: '14px' }}>
							Everything you love about Stamps.com, reimagined to be faster,
							cleaner, and easier to use.
						</Typography.P>

						<ul
							style={{
								paddingLeft: '10px',
								display: 'flex',
								flexDirection: 'column',
								gap: '8px',
								marginBottom: '8px',
							}}
						>
							<li>
								Improved speed and page load times across the application - up
								to 3x faster
							</li>
							<li>Improved responsiveness</li>
							<li>UI enhancements</li>
						</ul>

						{error && (
							<InlineMessage
								type="error"
								text="Something went wrong. Please try again."
								dataqa="labs-enable-error"
							/>
						)}

						<WrappedButton
							title="Try the new Experience"
							label="Try the new Experience"
							onClick={this.onEnableClick}
							disabled={saving}
							dataqa="labs-enable-button"
						/>
					</div>
				</Frame>
			</div>
		);
	}
}
